let _ = t => t,
  _t;
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/routing/NavItems';
import Screens from '../../constants/routing/Screens';
import { CREATE_A_BUNDLE } from '../../constants/tracking/Locations';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { hasPaidHubInProductInventorySelector, hasProductVersionInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { useQueryParamTerm, useQueryParamsEffect } from '../../utils/urls/appQueryParamUtils';
import PhoneSupport from '../common/PhoneSupport';
import AddonsPickerList from '../plan-builder/AddonsPickerList';
import HubPlanPickerListContainerAll from '../plan-builder/HubPlanPickerList/HubPlanPickerListContainerAll';
import PlanBuilder from '../plan-builder/PlanBuilder';
import SummaryColumn from '../plan-builder/SummaryColumn';
import ProductPageSubtitle from '../product-pages/ProductPageSubtitle';
import ProductPageTitle, { ProductPageHeader } from '../product-pages/ProductPageTitle';
import MobileWrapperNoTabs from './containers/MobileWrapperNoTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BottomSectionWrapper = styled.div.withConfig({
  displayName: "MobileBundlePage__BottomSectionWrapper",
  componentId: "sxr4rs-0"
})(["width:inherit;margin-top:34px;margin-left:10px;", ";"], breakpoint.cs(_t || (_t = _`
margin: 0 auto;
`)));
const MobileBundlePage = () => {
  useDocumentTitle('bundle');
  useTrackRetail();
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: Screens.BUNDLE
    });
  }, []);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  // const hasPricingAndPurchasingFailed = useSelector(
  //   hasPricingAndPurchasingFailedSelector
  // );

  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const initialProductConfigurations = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded || hasPaidHubInProductInventorySelector(state, {
      productLevels: [PROFESSIONAL, ENTERPRISE]
    })) {
      return [];
    }
    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    }).filter(({
      skuId
    }) => !hasProductVersionInProductInventorySelector(state, {
      skuId
    }));
  });
  return /*#__PURE__*/_jsxs(MobileWrapperNoTabs, {
    navMarkerName: 'BUNDLE_PAGE',
    navItem: NavItemEnum.BUNDLE,
    children: [/*#__PURE__*/_jsxs(ProductPageHeader, {
      children: [/*#__PURE__*/_jsx(ProductPageTitle, {
        nonProductIdentifier: NavItemEnum.BUNDLE
      }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
        nonProductIdentifier: NavItemEnum.BUNDLE
      })]
    }), /*#__PURE__*/_jsx(PlanBuilder, {
      initialProductConfigurations: initialProductConfigurations,
      allowUpgradesToCrmSuite: true,
      trackingSource: CREATE_A_BUNDLE,
      screen: Screens.BUNDLE,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HubPlanPickerListContainerAll, {
          productLines: ProductLines.AllProductLines
        }), /*#__PURE__*/_jsx(AddonsPickerList, {
          defaultOpen: true,
          screen: Screens.BUNDLE
        }), /*#__PURE__*/_jsxs(BottomSectionWrapper, {
          children: [/*#__PURE__*/_jsx(SummaryColumn, {
            shareLinkAnchor: "",
            hubsSignupProductOverride: "bundle"
          }), /*#__PURE__*/_jsx(PhoneSupport, {
            className: "m-top-5",
            phoneSourceId: "bundle",
            border: false,
            screen: Screens.BUNDLE
          })]
        })]
      })
    })]
  });
};
export default MobileBundlePage;